module.exports = __webpack_public_path__ + "static/img/hy3.7cccc960.png";